// ==========================================================================
// Push Subscription Service - Register/unregister FCM tokens with backend
// ==========================================================================

import api from '@/lib/axios';

export interface PushSubscriptionPayload {
  token: string;
  device_type: 'web' | 'pwa';
}

/** Detect if the app is running as an installed PWA (standalone mode). */
function isStandalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as unknown as { standalone?: boolean }).standalone === true
  );
}

/** Register an FCM token with the backend. */
export async function registerPushToken(token: string): Promise<void> {
  await api.post('/user/push-subscriptions', {
    token,
    device_type: isStandalone() ? 'pwa' : 'web',
  });
}

/** Unregister an FCM token from the backend. */
export async function unregisterPushToken(token: string): Promise<void> {
  await api.delete('/user/push-subscriptions', {
    data: { token },
  });
}
